import flatten from 'flat'
import { ModelTranslations } from '../components/langContext/languagesModel'

const target = {
	app: {
		devise: 'euros',
		details: 'En savoir plus',
		back: 'Retour'
	},
	errors: {
		dqe: {
			format_email: 'Format du courriel incorrect',
			creation_non_authorized: 'Création de compte non autorisée pour ce courriel',
			temporary_email: 'Veuillez ne pas utiliser une adresse mail temporaire pour votre compte YouFirst',
			full_inbox: 'Le courriel indiqué ne peut recevoir de nouveau message',
			email_not_found: 'Le courriel indiqué n\'a pas été trouvé pour ce domaine',
			invalid_phone: 'Le numéro de téléphone n\'est pas valide'
		}
	},
	fabField: {
		choixResidence: {
			ouiPreference: 'Oui de préférence',
			ouiAbsolument: 'Oui absolument',
			non: 'Non'
		},
		nombrePieces: {
			studio: 'Studio',
			piece2: 'Appartement 2 pièces',
			piece3: 'Appartement 3 pièces',
			piece4: 'Appartement 4 pièces',
			piece5: 'Appartement 5 pièces',
			piece6: 'Appartement 6 pièces et plus'
		},
		nombreChambres: {
			chambre1: '1 chambre',
			chambre2: '2 chambres',
			chambre3: '3 chambres',
			chambre4: '4 chambres et plus'
		},
		espaceExterieur: {
			balcon: 'Balcon',
			jardin: 'Jardin',
			terrasse: 'Terrasse'
		},
		typeVehicule: {
			voiture: 'Voiture',
			moto: 'Moto'
		},
		isStudent: {
			oui: 'OUI',
			non: 'NON',
		},
		isBoursier: {
			oui: 'OUI',
			non: 'NON',
		}
	},
	menu: {
		dashboard: 'Tableau de bord',
		news: 'Actualités',
		services: 'Services',
		contracts: 'Votre compte',
		requests: 'Vos demandes',
		questions: 'Questions ?',
		profile: 'Votre profil',
		dossier: 'Votre dossier',
		logout: 'Se déconnecter',
		accessibility: {
			title: {
				enableVisualHandicap: 'Consulter la version e-accessible',
				disableVisualHandicap: 'Quitter la version e-accessible'
			}
		}
	},
	dashboard: {
		welcome: 'Bienvenue sur\nvotre Espace Client',
		documents: 'Vos documents',
		questions: 'Questions fréquentes',
		request: 'Déposer une demande',
		repair: 'Guide des réparations locatives',
		contracts: {
			title: 'Votre compte',
			link: 'Tous vos contrats',
			emptyContractsText: 'Vous ne disposez d\'aucun contrat actif',
			emptyContractsLink: 'Consulter vos contrats clôturés',
			type: {
				apartment: 'Appartement',
				garage: 'Parking'
			},
			lease: 'Bail n°{lease} - ',
			balance: 'Solde',
			onGoingRequests: 'Vos demandes en cours',
			onGoingText: 'Demande administrative {date}',
			recentsDocuments: 'Vos documents récents',
			details: 'Voir le détail'
		},
		news: {
			emptyState: 'Aucune actualité à afficher pour votre résidence'
		}
	},
	requests: {
		title: 'Vos demandes en cours',
		titleTreated: ' Vos demandes clôturées',
		emptyRequests: 'Aucune demande en cours',
		emptyRequestsSubText: 'Toutes vos demandes ont été traitées',
		link: 'Afficher vos demandes clôturées',
		createdAt: 'Créée le {date}',
		updatedAt: 'Mise à jour le {date}',
		closedAt: 'Clôturée le {date}',
		canceledAt: 'Annulée le {date}',
		responseNotFound: 'Vous n’avez pas trouvé de réponse dans nos questions fréquentes ?',
		anotherRequest: 'Vous souhaitez déposer une nouvelle demande ?',
		frequentQuestions: 'Les questions fréquentes',
		havingQuestions: 'Vous avez une question ? {br} Trouvez votre réponse rapidement en consultant nos questions fréquentes par thématique.',
		reparations: 'Votre guide des réparations locatives',
		welcome: 'Votre livret d\'accueil',
		download: 'Télécharger',
		visit: 'Consulter',
		otherCategory: 'Autre',
		makeRequest: {
			title: 'Déposer une demande',
			more: 'Pourriez-vous nous en dire davantage ?',
			subHeader: {
				technical: 'Demande technique',
				administrative: 'Demande administrative'
			},
			step0: {
				title: 'Quel est le type de votre demande ?'
			},
			step1: {
				title: 'Quel est l’objet de votre demande ?',
				technical: 'Technique',
				administrative: 'Administrative'
			},
			guideReparations: {
				text1: 'Avant de créer une demande technique, nous vous invitons à consulter  <span>le guide des réparations locatives.</span> Cela vous permettra de vérifier rapidement si la réparation souhaitée est à votre charge ou celle de YouFirst. Si après vérification la réparation est bien à la charge de YouFirst Résidence dans les parties privatives, merci de compléter ce formulaire.',
				text2: 'Un évier bouché ? Une vitre cassée ? Un interrupteur défectueux ? Vous allez être aidé pour mieux comprendre ce qui est à votre charge et ce qui est à la charge de YouFirst Résidence dans les parties privatives.',
				link: 'Consulter le guide des réparations locatives'
			},
			step2: {
				title: 'Quel est l’objet de votre demande ?',
				titlePrivate: 'Sélectionner l\'élément concerné par votre demande',
				private: 'Parties privatives',
				common: 'Parties communes',
				sinisters: 'Sinistres',
				bill: 'Règlement et Facturation',
				neighbor: 'Vie de la résidence et du voisinage',
				contract: 'Vie du contrat',
				deposit: 'Résiliation du bail',
				debit: 'Prélèvement automatique',
				assurance: 'Attestation d\'assurance habitation'
			},
			step3: {
				title: 'Quel est le bien concerné ?',
				titleDeposit: 'Quels sont les contrats concernés ?',
				heater: 'Chauffage',
				electricity: 'Electricité',
				ventilation: 'Ventilation',
				joinery: 'Menuiserie, serrurerie',
				plumbing: 'Plomberie',
				disinfection: 'Désinsectisation, dératisation, désinfection',
				authorization: 'Autorisation/ demande de travaux',
				hotWater: 'Eau chaude',
				water: 'Eau',
				gaz: 'Gaz',
				waterInfiltration: 'Infiltration',
				miscellaneous: 'Divers',
				shutter: 'Volet roulants',
				others: 'Autres',
				elevator: 'Ascenseur',
				security: 'Equipement de sécurité',
				door: 'Accès (Hall, porte parking, Interphone)',
				light: 'Eclairage',
				maintenance: 'Entretien Parties Communes',
				technicalLocal: 'Local technique (Vide ordure, local à vélo...)',
				letters: 'Boîte aux lettres',
				optic: 'Fibre Optique',
				renovation: 'Rénovation / Construction',
				electrical: 'Borne électrique',
				waterDamages: 'Dégât des eaux',
				fire: 'Incendie',
				brokenGlass: 'Bris de glace',
				rent: 'Loyer, Révisions...',
				rentalCharge: 'Charges Locatives',
				debit: 'Prélèvement Automatique',
				paymentNotCashed: 'Règlement non encaissé',
				contestBill: 'Contestation de Facturation',
				parking: 'Stationnement abusif / épave',
				clutter: 'Encombrement des parties communes',
				trade: 'Liées à un commerce',
				smell: 'Odeurs / salissures',
				sound: 'Trouble de jouissance',
				requestParking: 'Demande de place parking / changement',
				requestHome: 'Demande de domiciliation d’entreprise',
				occupantsModification: 'Modification des occupants',
				transferDocuments: 'Transmission de documents',
				renewLease: 'Renouvellement de bail',
				key: 'Clé ou badge',
				changeFlat: 'Changez d\'appartement',
				deliveryBox: 'Boîte à colis connectée',
				sharedLib: 'Bibliothèque à partager',
				plumbingCommon: 'Plomberie',
				deposit: 'Résiliation du bail',
				assurance: 'Attestation d\'assurance habitation',
				link: 'Cliquez ici pour télécharger le guide des réparations locatives',
				entree: 'Porte d\'entrée',
				serruresbarillets: 'Serrures et barillets',
				clesbadges: 'Clés et badges d’accès',
				electriciteeclairage: 'Électricité et éclairage',
				detecteurfumee: 'Détecteur de fumée',
				fenetresencadrements: 'Fenêtres et encadrements',
				voletsbasse: 'Volets roulants, stores et jalousies – partie basse (manivelle)',
				voletshaute: 'Volets roulants, stores et jalousies – partie haute (mécanisme)',
				vitrage: 'Vitrage',
				convecteursradiateurs: 'Convecteurs électriques et radiateurs',
				mursinterieurs: 'Murs intérieurs, cloisons et plafonds',
				parquets: 'Parquets',
				moquetterevetements: 'Moquette et autres revêtements',
				aerationventilation: 'Aération et ventilation',
				vmc: 'VMC (ventilation mécanique contrôlée)',
				arriveegaz: 'Arrivée de gaz',
				flexiblegaz: 'Flexible de gaz',
				flexiblegrillesiphon: 'Flexible, grille et siphon (évier, lavabo, douche)',
				colonneeaux: 'Colonne d’eaux usées',
				canalisationseauusees: 'Canalisations d’eau et eaux usées',
				abattantswc: 'Abattants de WC',
				canalisationeau: 'Canalisation d\'eau',
				douchetteflexibledouche: 'Douchette et flexible de douche',
				carrelagefaience: 'Carrelage et faïence',
				robinetterie: 'Robinetterie',
				chasseeau: 'Chasse d’eau',
				evierslavabosbaignoiressanitaires: 'Éviers, lavabos, baignoires et sanitaires',
				chaudieremuraleballonelectrique: 'Chaudière murale et ballon électrique',
				cave: 'Cave',
				boxstationnement: 'Box de stationnement',
				terrassebalcon: 'Terrasse & balcon',
				divers: 'Divers',
				electromenager: 'Electroménager',
				equipementsconfort: 'Mobilier et équipements',
				private: {
					boutons: {
						bailleur: 'Demande d’intervention',
						locatif: 'Demande d’information',
					},
					legende: {
						bailleur: 'À LA CHARGE DE YOUFIRST',
						locatif: 'À VOTRE CHARGE',
					},
					description: {
						entree: 'Si la porte est déformée, abîmée par vétusté ou présente un défaut structurel, le remplacement est à la charge de YouFirst.',
						serruresbarillets: 'Si vous perdez vos clés ou cassez la serrure en l’utilisant, vous devez remplacer le barillet.',
						clesbadges: 'En cas de perte ou de casse, vous devez remplacer vos clés/badges d’accès.',
						electriciteeclairage: 'Si une ampoule grille ou un fusible saute, vous devez les remplacer.',
						detecteurfumee: 'Si le détecteur sonne, bippe ou ne fonctionne plus, vous devez dépoussiérer l’appareil, remplacer les piles ou le détecteur si nécessaire.',
						fenetresencadrements: 'Si l’encadrement est endommagé par vétusté ou les joints défectueux, YouFirst doit intervenir.',
						voletsbasse: 'Si la manivelle est abîmée, vous devez la réparer ou la remplacer.',
						voletshaute: 'Si le mécanisme supérieur (rouleau, moteur) est en panne, c’est à YouFirst de le réparer.',
						vitrage: 'Si une vitre est cassée suite à un choc, vous devez la remplacer.',
						convecteursradiateurs: 'Si un appareil est encrassé ou ne chauffe pas correctement, vous devez le dépoussiérer et vérifier son bon usage.',
						mursinterieurs: 'Si vous faites des trous ou des taches, vous devez reboucher et nettoyer.',
						parquets: 'Si le sol est rayé ou taché, vous devez le nettoyer ou le réparer.',
						moquetterevetements: 'Si des taches apparaissent, vous devez nettoyer ou remplacer',
						aerationventilation: 'Si l’air circule mal, nettoyez les grilles et bouches d’aération.',
						vmc: 'Dépoussiérer les bouches d’aération, nettoyer les filtres et vérifier que l’air circule bien.',
						arriveegaz: 'Si l’installation générale présente un défaut ou nécessite une mise en conformité, YouFirst prend en charge.',
						flexiblegaz: 'Si l\'installation du flexible ne répond plus aux normes de sécurité (usure structurelle, installation défectueuse), YouFirst prend en charge',
						flexiblegrillesiphon: 'Si des traces de calcaire ou des bouchons apparaissent, vous devez nettoyer et déboucher.',
						colonneeaux: 'Si une fuite provient d’une canalisation encastrée ou d’une colonne d’immeuble, YouFirst doit la réparer.',
						canalisationseauusees: 'Si une fuite survient ou qu’un défaut structurel apparaît, YouFirst prend en charge la réparation et reste responsable des canalisations principales.',
						abattantswc: 'Si l’abattant est cassé ou usé, vous devez le remplacer.',
						canalisationeau: 'Si un siphon est bouché, vous devez le déboucher.',
						douchetteflexibledouche: 'Si le flexible est percé ou entartré, vous devez le remplacer.',
						carrelagefaience: 'Si vous cassez un carreau, vous devez le remplacer.',
						robinetterie: 'Si un robinet fuit ou goutte, vous devez changer les joints ou cartouches.',
						chasseeau: 'Si la chasse fuit, vous devez remplacer les joints ou le flotteur.',
						evierslavabosbaignoiressanitaires: 'Si des pièces sont cassées ou endommagées, détartrez ou remplacez les éléments',
						chaudieremuraleballonelectrique: 'En cas de panne liée à l’usure ou à un défaut structurel, le remplacement est à la charge de YouFirst',
						cave: 'Si vous laissez des déchets ou l’encombrez, vous devez la nettoyer.',
						boxstationnement: 'Si vous détériorez la serrure ou la porte en manœuvrant, vous devez la réparer.',
						terrassebalcon: 'Si le balcon est encrassé ou encombré, vous devez le nettoyer.',
						divers: 'Vous ne retrouvez pas votre cas dans les différentes catégories ? Cliquez sur le bouton ci-dessous et expliquez-nous votre problématique. Nous reviendrons vers vous dans les meilleurs délais.',
						electromenager: 'Si un appareil tombe en panne suite à un mauvais usage, vous devez le remplacer.',
						equipementsconfort: 'Si vous cassez, perdez ou endommagez un élément (mobilier, vaisselle, décoration), vous devez le remplacer.',
					}
				}
			},
			step4: {
				title: 'Précisez votre demande',
				titlePlaceholder: 'Saisissez l\'objet de votre demande',
				messagePlaceholder: 'Saisissez votre message',
				messageOptionnelPlaceholder: 'Saisissez votre message (optionnel)',
				attachmentLabel: 'Ajouter une pièce jointe',
				submit: 'Envoyez votre demande',
				chooseOption: 'Afin de nous permettre de programmer une intervention, si nécessaire, nous vous invitons à sélectionner l\'une des trois options suivantes :',
				keyExampleOption: 'Je laisse un exemplaire de mes clés au bureau d\'accueil de mon YouFirst Manager',
				datesOption: 'Je sélectionne trois créneaux',
				advisorOption: 'Je préfère être contacté par mon YouFirst Manager',
				choice1: 'Choix 1',
				choice2: 'Choix 2',
				choice3: 'Choix 3',
				dateText: 'Date',
				timeSlotText: 'Créneau',
				assurance: {
					dateDebut: {
						label: 'Date de début d\'assurance',
						sublabel: 'Renseignez ici la date de début de votre nouvelle attestation d\'assurance',
						echeance: 'Date début de l’assurance : '
					},
					dateFin: {
						label: 'Date de fin d\'assurance',
						sublabel: 'Renseignez ici la date de fin de votre nouvelle attestation d\'assurance',
						echeance: 'Date fin de l’assurance : '
					},
					information: 'Veuillez nous transmettre votre attestation d’assurance.'
				},
				deposit: {
					info_resi: {
						title: 'Chez YouFirst nous voulons simplifier votre quotidien, même quand vous nous dîtes au revoir. Pour nous notifier votre départ, nous vous proposons <strong>un parcours rapide et 100% digital</strong>, y compris pour les étapes légales.',
						first: 'Vous déposez votre demande de résiliation du bail sur votre Espace client :',
						second: 'Vous renseignez le formulaire ci-dessous avec les informations relatives à votre demande de résiliation.',
						third: 'Vous signez cette demande électroniquement via la plateforme de signature sécurisée YouSign.',
						fourth: 'C’est fini : vous avez donné votre congé en respectant toutes les formalités. <strong>Votre préavis d’un mois minimum (ou de 3 mois pour un bail code civil) démarre à la signature. Pas de fastidieux courrier recommandé avec accusé de réception</strong> : vous pouvez vous consacrer à vos cartons.',
						five: 'Après la signature de votre demande de résiliation, veuillez attendre quelques minutes avant de voir votre demande s’afficher sur votre espace personnel.',
						formalize: 'Nous formalisons votre demande de résiliation du bail avec les informations renseignées.'
					},
					info_campus: {
						title: 'Chez YouFirst, nous voulons simplifier votre quotidien, même quand vous nous dîtes au revoir. Pour nous notifier votre départ, nous vous proposons <strong>un parcours rapide et 100% digital</strong>, y compris pour les étapes légales.',
						first: 'Vous déposez votre demande de résiliation du bail sur votre Espace client :',
						second: 'Vous renseignez le formulaire ci-dessous avec les informations relatives à votre demande de résiliation.',
						third: 'Vous signez cette demande électroniquement via la plateforme de signature sécurisée YouSign.',
						fourth: 'C’est fini : vous avez donné votre congé en respectant toutes les formalités. <strong>Votre préavis d’un mois démarre à la signature. Pas de fastidieux courrier recommandé avec accusé de réception</strong> : vous pouvez vous consacrer à vos cartons.',
						five: 'Après la signature de votre demande de résiliation, veuillez attendre quelques minutes avant de voir votre demande s’afficher sur votre espace personnel.',
						formalize: 'Nous formalisons votre demande de résiliation du bail avec les informations renseignées.'
					},
					date: {
						info: 'Pour rappel, le délai de préavis est d’un mois. Si vous choisissez une date de départ avant l\'expiration de ce délai, le loyer reste dû jusqu’à son expiration.',
						label: 'Date de départ souhaitée'
					},
					phone: 'Numéro de téléphone mobile',
					preCheckLocation: 'Vos préférences pour le rendez-vous de pré-état des lieux',
					checkLocation: 'Vos préférences pour le rendez-vous d’état des lieux (sous réserve de disponibilité des équipes YouFirst)',
					checkLocationInfo: 'La remise des clés se fait le jour de l’état des lieux de sortie.',
					datesOption: 'Je sélectionne trois créneaux',
					advisorOption: 'Je préfère être contacté par mon YouFirst manager',
					leaveReason: {
						label: 'Motif de départ',
						campus: {
							changeSchool: 'Changement d’école / de fac',
							changeStatus: 'Changement de statut / fin d\'études',
							intership: 'Stage / Départ à l’étranger',
							otherType: 'Souhait autre type d’appartement',
							unsatisfied: 'Insatisfaction liée à YouFirst Campus',
							foundCheaper: 'Rapport qualité / prix, a trouvé un logement moins cher',
							surrounding: 'Environnement : Pollution sonore / Insécurité',
							other: 'Autre (veuillez préciser)'
						},
						both: {
							family: 'Changement de situation familiale',
							professional: 'Changement de situation professionnelle',
							otherType: 'Souhait autre type d’appartement / parking',
							neighbour: 'Problème de voisinage',
							acquisition: 'Acquisition',
							budget: 'Raison financière',
							residence: 'Insatisfaction liée à la résidence / parking',
							apartment: 'Insatisfaction liée à l’appartement / parking',
							other: 'Autre'
						},
						apartment: {
							family: 'Changement de situation familiale',
							professional: 'Changement de situation professionnelle',
							otherType: 'Souhait autre type d’appartement',
							neighbour: 'Problème de voisinage',
							acquisition: 'Acquisition',
							budget: 'Raison financière',
							residence: 'Insatisfaction liée à la résidence',
							apartment: 'Insatisfaction liée à l’appartement',
							other: 'Autre'
						},
						parking: {
							vehicle: 'Changement de véhicule',
							otherType: 'Souhait autre type de parking',
							acquisition: 'Acquisition',
							principalChanged: 'Changement de résidence principale',
							professional: 'Raison professionnelle',
							parking: 'Insatisfaction liée au parking',
							residence: 'Insatisfaction liée à la résidence',
							other: 'Autre'
						}
					},
					comment: 'Commentaire',
					isAlone: 'Je suis seul à quitter l\'appartement, et ce congé est donc adressé en mon nom seul',
					hasCopreneurs: 'Pour cette demande, je m’engage au nom de tous les titulaires du bail, et ce congé est donc adressé au nom et pour le compte de l\'ensemble des titulaires',
					isStandalone: 'Dépôt de congé individuel ou collectif',
					rib: {
						info: 'Afin de procéder au remboursement de votre dépôt de garantie, si l’état des lieux de sortie est conforme à celui d’entrée, nous vous invitons à ajouter votre RIB en pièce jointe.',
						attachment: 'Ajouter un RIB',
						allow: {
							label: 'J’autorise YouFirst Campus à procéder au remboursement de mon dépôt de garantie sur le compte du titulaire mentionné en pièce jointe',
							error: 'Vous devez autoriser YouFirst Campus à procéder au remboursement sur la base du RIB fourni'
						}
					},
					submit: 'Continuer votre demande',
					erreurs: {
						residence: 'Une erreur est survenue, veuillez contacter votre Gestionnaire Locatif',
						campus: 'Une erreur est survenue, veuillez contacter votre YouFirst Manager'
					}
				}
			},
			step5: {
				iframeTitle: 'Signature de la résiliation du bail',
				title: 'Votre demande a bien été envoyée.',
				text: 'Nous vous contactons dans les meilleurs délais.',
				textRdv : 'Pensez à prendre rendez-vous dès maintenant pour votre Etat des lieux de sortie et remise des clés auprès de votre YouFirst Manager.',
				finish: 'Terminer',
				rdv: 'Prendre rendez-vous',
				remakeRequest: 'Déposer une nouvelle demande'
			},
			previousStep: 'Étape précédente',
			nextStep: 'Étape suivante'
		},
		response: {
			title: 'Transmettre une réponse',
			submit: 'Envoyez votre réponse'
		},
		detail: {
			back: 'Toutes vos demandes',
			btnAnswer: 'Écrire votre message',
			title: 'Votre demande',
			sentAt: 'Envoyée le {date}',
			nbAnswers: '{nbAnswers, plural, one {réponse} other {réponses}}',
			myAnnotations: 'Vous avez joint {nbAnnotations} fichier(s)',
			responseService: 'Votre équipe YouFirst',
			sentAMessage: 'Vous avez envoyé un message',
			errorPreviewAnnotation: 'La pièce jointe n\'existe pas',
			keyOptionChosen: 'Vous avez choisi de déposer un exemplaire de vos clés au bureau d\'accueil de votre YouFirst Manager',
			advisorOptionChosen: 'Vous avez choisi d\'être contacté par votre YouFirst Manager',
			datesOptionChosen: 'Vous avez choisi les créneaux de disponibilité suivants :'
		},
		weekDays: {
			Lundi: 'Lundi',
			Mardi: 'Mardi',
			Mercredi: 'Mercredi',
			Jeudi: 'Jeudi',
			Vendredi: 'Vendredi'
		},
		timeSlots: {
			Matin: 'Matin',
			'Après-midi': 'Après-midi'
		}
	},
	faq: {
		faq_title: 'Comment pouvons-nous vous aider ?',
		placeholder: 'Renseignez vos mots clés (ex: quittance, bail, sinistre)',
		smallPlaceholder: 'Renseignez vos mots clés',
		category: 'Ou choisissez une catégorie de questions fréquentes ',
		lease: 'Votre Bail',
		appartment: 'Votre Appartement',
		services: 'Vos Services',
		customer: 'Votre Espace Client',
		no_answer: 'Vous n’avez pas trouvé de réponses ?',
		ask: 'Posez-nous directement votre question',
		request: 'Déposer une demande',
		contact: 'Nous contacter',
		searchEmpty: 'Aucune question ne correspond à votre recherche'
	},
	you_first_manager: {
		listenDefault: 'Nous sommes à votre écoute',
		manager: 'Votre YouFirst Manager ',
		managers: 'Vos YouFirst Managers',
		sendMsg: 'Envoyer un message',
		availabilityManager: 'Numéros d\'urgence à utiliser en dehors des horaires d\'ouverture du bureau d\'accueil.',
		technical: 'Urgence technique',
		elevator: 'Ascensoriste',
		heating: 'Chauffagiste',
		parking: 'Portes de parking',
		emergency: 'N° d’urgence',
		defaultYfm: 'Votre équipe YouFirst'
	},
	news: {
		title: 'Actualités',
		link: 'Toutes les actualités',
		breadcrumb: {
			actualite_exploitation: 'Informations pratiques',
			actualite_marketing: 'La vie de votre résidence'
		},
		questions: {
			title: 'Vous avez une question ?',
			text: 'Trouvez votre réponse rapidement en consultant nos questions fréquentes par thématique.',
			button: 'Consulter'
		},
		ariaLabel: 'En savoir plus sur l\'actualité : {news}',
		seeAllNews: 'Voir toutes les actualités',
		details: {
			error: 'L\'actualité demandée n\'a pas été trouvée'
		}
	},
	topAlert: {
		ariaLabel: 'En savoir plus sur l\'alerte : {alert}',
		details: {
			error: 'L\'alerte demandée n\'a pas été trouvée'
		}
	},
	customAlert: {
		title: 'Prélèvement automatique',
		informations: 'Adoptez le prélèvement automatique et simplifiez-vous la gestion de votre location.',
		hideAlert: 'Masquer l\'alerte',
		subscribe: 'Souscrire',
		assurance: {
			title: 'Important',
			deposit: 'Déposer votre attestation',
			finie: {
				informations: 'Votre attestation d\'assurance a expiré. Nous vous invitons à nous la transmettre au plus vite'
			},
			proche: {
				informations: 'Votre attestation d’assurance arrive bientôt à échéance. Pensez à nous transmettre votre nouvelle attestation au plus vite',
			}
		}
	},
	contracts: {
		title: 'Vos contrats',
		docsTab: 'Vos documents',
		accountTab: 'Votre relevé de compte',
		document: {
			date: 'Date',
			name: 'Nom',
			ddl: 'Téléchargement',
			emptyDocs: 'Vous ne disposez d\'aucun document correspondant à votre sélection',
			selectAll: 'Tous',
			andBefore: 'et avant',
			serverErrors: {
				noDocument: 'Erreur lors de la récupération des documents'
			}
		},
		account: {
			balance: 'Votre solde',
			payBalance: 'Payer le solde',
			payBalanceTitle: 'Le solde de votre compte sera mis à jour 24 heures après votre règlement',
			leftToPay: 'Reste à payer ',
			accountDetails: 'Votre relevé de compte',
			deadline: 'Echéance',
			operation: 'Libellé opération',
			amount: 'Montant',
			status: 'Statut',
			onDay: 'au ',
			euro: ' €',
			emptyOp: 'Aucune opération à afficher',
			toPay: 'À régler',
			paid: 'Réglé',
			debitBalance: 'Solde débiteur',
			payment: {
				title: 'Paiement sécurisé',
				all: {
					subtitle: 'Paiement de votre solde',
					description: 'Vous vous apprêtez à régler le montant de : '
				},
				partial: {
					subtitle: 'Effectuez votre paiement',
					description1: 'Vous vous apprêtez à régler votre facture ',
					description2: 'Le montant total doit être réglé en une seule fois.',
					amountNegative: 'Le montant ne peut pas être négatif',
					amountZero: 'Le montant ne peut pas être nul',
					amountMax: 'Le montant ne peut excéder {amount}',
					amountString: 'Le montant ne peut contenir que des nombres',
					amountExact: 'Le montant total de la facture doit être réglé',
					btnPartial: 'Reste à payer : {amount}€',
					btnFull: 'À régler : {amount}€'
				},
				finished: {
					success: {
						title: 'Votre règlement a bien été pris en compte.',
						description: 'Votre solde sera mis à jour dans un délai de <strong>24 heures</strong>.<p>' +
							'Nous vous remercions de votre confiance.</p>' +
							'Votre équipe YouFirst'
					},
					error: {
						title: 'Votre paiement n\'a pas pu aboutir. Vous ne serez pas débité.',
						description: {
							'00001': 'Nous vous invitons à essayer à nouveau ultérieurement, avec une carte de paiement différente ou à vous rapprocher de votre Attaché(e) de gestion.',
							'001': 'Nous vous invitons à essayer à nouveau ultérieurement, avec une carte de paiement différente ou à vous rapprocher de votre Attaché(e) de gestion.',
							'00003': 'Nous vous invitons à essayer à nouveau ultérieurement, avec une carte de paiement différente ou à vous rapprocher de votre Attaché(e) de gestion.',
							'00004': 'Nous vous invitons à essayer à nouveau ultérieurement, avec une carte de paiement différente ou à vous rapprocher de votre Attaché(e) de gestion.',
							'00006': 'Nous vous invitons à vous rapprocher de votre Attaché(e) de gestion.',
							'00008': 'Nous vous invitons à essayer à nouveau ultérieurement, avec une carte de paiement différente ou à vous rapprocher de votre Attaché(e) de gestion.',
							'00009': 'Nous vous invitons à vous rapprocher de votre Attaché(e) de gestion.',
							'00010': 'Nous vous invitons à essayer à nouveau ultérieurement, avec une carte de paiement différente ou à vous rapprocher de votre Attaché(e) de gestion.',
							'00011': 'Nous vous invitons à essayer à nouveau ultérieurement, avec une carte de paiement différente ou à vous rapprocher de votre Attaché(e) de gestion.',
							'00016': 'Nous vous invitons à vous rapprocher de votre Attaché(e) de gestion.',
							'00021': 'Il semble que votre carte est invalide. Les cartes acceptées sont CB Visa et MasterCard. Nous vous invitons à essayer à nouveau avec l\'une de ses cartes ou à vous rapprocher de votre Attaché(e) de gestion.',
							'00029': 'Nous vous invitons à essayer à nouveau ultérieurement, avec une carte de paiement différente ou à vous rapprocher de votre Attaché(e) de gestion.',
							'00030': 'Le délai de paiement a été dépassé, nous vous invitons à essayer à nouveau ou à vous rapprocher de votre Attaché(e) de gestion.',
							'00033': 'Nous vous invitons à essayer à nouveau ultérieurement, avec une carte de paiement différente ou à vous rapprocher de votre Attaché(e) de gestion.',
							'00040': 'Nous vous invitons à essayer à nouveau ultérieurement, avec une carte de paiement différente ou à vous rapprocher de votre Attaché(e) de gestion.'
						}
					}
				},
				btn: 'Payer en ligne'
			}
		}
	},
	profile: {
		title: 'Votre profil',
		personalInfo: 'Vos informations personnelles',
		email: 'COURRIEL',
		newEmail: 'NOUVEAU COURRIEL',
		emailConfirm: 'CONFIRMATION DU COURRIEL',
		previousPassword: 'ANCIEN MOT DE PASSE',
		newPassword: 'NOUVEAU MOT DE PASSE',
		password: 'MOT DE PASSE',
		phone: 'TÉLÉPHONE MOBILE',
		modify: 'Modifier',
		modifyEmail: 'Modifier votre courriel',
		modifyPassword: 'Modifier votre mot de passe',
		modifyPhone: 'Modifier votre numéro de téléphone',
		payments: 'Vos moyens de paiement',
		paymentDesc: 'Afin de simplifier vos règlements, YouFirst vous propose de souscrire au prélèvement automatique pour vos contrats.',
		paymentBtn: 'Souscrire au prélévement automatique',
		subscriptionPaymentInProgress: 'Votre demande de passage au prélèvement automatique est en attente de confirmation par votre gestionnaire.',
		paymentLabel: 'BAIL N°{numero}, LOT(S) {lot} - {address}',
		preferences: 'Vos préférences',
		eReleveDesc: 'Une notification par courriel vous sera envoyée à chaque dépôt d\'un nouveau document comptable sur votre Espace Client. Vous aurez la possibilité de le consulter et de le télécharger au besoin. Si vous souhaitez les recevoir également par courrier, veuillez décocher cette case.',
		eReleve: 'SOUSCRIPTION E-RELEVÉ',
		language: 'Vous préférez échanger avec nous en :',
		youfirstInformations: {
			titleCampus: 'Actualités YouFirst Campus',
			titleResi: 'Actualités YouFirst',
			info: 'Les actualités de votre résidence portent sur la vie dans l\'immeuble et notre relation. Une notification par courriel vous sera envoyée à chaque publication d\'une nouvelle actualité sur votre Espace Client.',
			secondInfo: 'Si vous décochez la réception des emails et/ou sms, vous continuerez à recevoir les informations liées à la vie du bail : coupure d\'eau, panne ascenseur, etc',
			email: {
				label: 'COURRIEL'
			},
			sms: {
				label: 'SMS'
			},
			infoTitleCampus: 'Informations YouFirst Campus',
			infoTitleResi: 'Informations YouFirst Residence',
			infoMessage: 'Vous recevrez des informations de votre future résidence.'
		},
		followEmail: {
			label: 'Suivi de l\'ouverture de mes e-mails',
			text: 'Mes données personnelles seront utilisées et partagées conformément à la Politique de confidentialité et YouFirst utilise des pixels de suivi, afin de mesurer mes interactions avec les communications qui me sont adressées et d\'en améliorer la pertinence.',
			lienGecina: 'Politique de confidentialité Gecina',
			lienYoufirst: 'Politique de confidentialité YouFirst',
			accept: 'J\'accepte',
			refuse: 'Je refuse'
		},
		errors: {
			default_error: 'Une erreur est survenue lors de la modification de l\'utilisateur',
			crm_edit_phone: 'Une erreur est survenue lors de la modification du numéro de téléphone',
			crm_edit_email: 'Une erreur est survenue lors de la modification du courriel',
			okta_edit_email: 'Une erreur est survenue lors de la modification du courriel',
			okta_default_error: 'Une erreur est survenue lors de la récupération de l\'utilisateur',
			okta_user_not_found: 'L\'utilisateur n\'a pas été trouvé',
			okta_missing_requirements: 'Une erreur est survenue lors de la modification du mot de passe : le mot de passe doit contenir 8 caractères dont au moins une majuscule, un chiffre et une minuscule',
			okta_recent_password: 'Une erreur est survenue lors de la modification du mot de passe : le mot de passe a été utilisé récemment',
			okta_old_password: 'Une erreur est survenue lors de la modification du mot de passe : l\'ancien mot de passe n\'est pas correct',
			okta_edit_password: 'Une erreur est survenue lors de la modification du mot de passe pour l\'utilisateur',
			missing_old_email: 'Une erreur est survenue lors de la modification de l\'utilisateur : l\'ancien courriel est manquant',
			preferences: 'Une erreur est survenue lors de la modification des préférences',
			get_user_data: 'Une erreur est survenue lors de la récupération des données utilisateurs'
		},
		success: 'Modifications prises en compte',
		prelevement: {
			button: 'Passer au prélèvement',
			title: 'Souscrire au prélèvement automatique',
			subtitle: 'Pourriez-vous compléter vos informations ?',
			subHeader: {
				bail: '{nbContracts, plural, one {Bail} other {Baux}} n° {bail}'
			},
			step0: {
				title: 'Contrats pour lesquels vous souhaitez souscrire au prélèvement automatique'
			},
			step1: {
				title: 'Complétez les informations personnelles du débiteur',
				firstname: 'Prénom',
				lastname: 'Nom',
				street: 'N° et rue',
				postalCode: 'Code postal',
				city: 'Ville',
				country: 'Pays',
				email: 'Courriel',
				phone: 'Téléphone',
				sms: 'Un SMS vous sera envoyé lors de la signature électronique du document',
				errorPhone: 'Une erreur est survenue, veuillez vérifier votre numéro de téléphone',
				internalError: 'Une erreur est survenue, veuillez réessayer ultérieurement',
				generationMandatError: 'Génération du mandat de prélèvement impossible'
			},
			step2: {
				title: 'Complétez vos informations bancaires :',
				iban: 'Code IBAN',
				bic: 'Code BIC',
				rib: 'Ajouter votre RIB'
			},
			step3: {
				iframeTitle: 'Signature du mandat de prélèvement',
				title: 'Votre demande a bien été prise en compte.',
				subTitle: 'Nous revenons vers vous au plus vite concernant votre souscription au prélèvement automatique'
			}
		}
	},
	services: {
		title: 'Services',
		link: 'Tous les services',
		emptyState: 'Des services seront bientôt disponibles dans votre résidence, stay tuned !',
		details: {
			seeAllServices: 'Voir tous les services',
			error: 'Le service demandé n\'a pas été trouvé',
			title: 'Les autres services YouFirst'
		},
		modal: {
			form: {
				title: 'Le service "{title}" vous intéresse',
				subtitle: 'Avez-vous des questions spécifiques ?',
				submit: 'Envoyer'
			},
			summary: {
				title: 'Votre demande a bien été prise en compte.',
				text: 'Nous revenons vers vous dans les meilleurs délais concernant le service qui a suscité votre intérêt.'
			}
		}
	},
	popinCGU: {
		title: 'Conditions Générales d\'Utilisation'
	},
	popinEcDesactive: {
		title: 'Espace client désactivé',
		text: 'Chère madame, cher monsieur, {br} L\'accès à l\'espace client est indisponible. {br} Veuillez contacter le support pour obtenir de l\'aide'
	},
	enums: {
		paymentsMode: {
			CHQ: 'Chèque',
			PRLAUTO: 'Prélévement automatique',
			TIP: 'TIP',
			LCH: 'LCH',
			VIRAUTO: 'Virement automatique',
			VIRM: 'Virement'
		},
		languages: {
			fr: 'Français',
			en: 'Anglais'
		}
	},
	global: {
		back: 'Retour',
		fields: {
			select: {
				default: 'Choisir'
			}
		},
		errors: {
			required: 'Requis*',
			formatEmail: 'Format du courriel incorrect',
			notSameEmail: 'Le courriel saisi et sa confirmation sont différents',
			formatPassword: 'Le mot de passe doit comporter au moins 8 caractères dont au moins un chiffre, une lettre minuscule et une lettre majuscule',
			formatPhone: 'Le numéro de téléphone ne doit pas faire plus de 20 caractères',
			sameDateChoice: 'Date et créneau déjà choisis',
			fileSize: 'Ajout du fichier impossible car le fichier dépasse 30Mo',
			authorizedExt: 'Fichiers autorisés : .png, .jpg, .jpeg, .gif, .pdf',
			sameCreneau: 'Vous ne pouvez pas choisir 2 fois le même créneau'
		},
		btn: {
			save: 'Enregistrer',
			cancel: 'Annuler',
			accept: 'Accepter',
			refuse: 'Refuser',
			next: 'Suivant',
			validate: 'Valider',
			finish: 'Terminer',
			continue: 'Envoyez votre demande'
		},
		switch: {
			enabled: 'Activé',
			disabled: 'Désactivé'
		}
	},
	footer: {
		details: {
			error: 'La page demandée n\'a pas été trouvée'
		}
	},
	cookie: {
		title: 'Gestion des cookies',
		text: 'Ce site utilise Google Analytics. En acceptant, vous nous autorisez à déposer des cookies à des fins de mesure d\'audience. {br} Pour plus d\'information, consultez notre page {page}',
		link: 'Politique de gestion des cookies'
	},
	changementAppartement: {
		enCours: {
			titre: {
				ajoutAppartement: 'Votre demande de location d\'appartement',
				changementAppartement: 'Votre demande de changement d\'appartement',
				ajoutParking: 'Votre demande de location de parking',
				changementParking: 'Votre demande de changement de parking'
			},
			bouton: 'Consulter votre demande'
		},
		titre: 'Vous souhaitez changer votre location ou ajouter une autre ?',
		sousTitre: 'Dites-nous en plus sur votre besoin',
		changerAppartement: 'Changer d\'appartement',
		ajouterAppartement: 'Ajouter un appartement',
		changerParking: 'Changer de parking',
		ajouterParking: 'Ajouter un parking',
		formulaire: {
			titre: 'Votre nouveau besoin',
			choixResidence: {
				label: 'Souhaitez-vous rester dans la même résidence ?'
			},
			ville: {
				label: 'Villes et arrondissement souhaités',
				placeholder: 'Choisissez parmi la liste',
				paris: 'Paris (75)',
				paris1: '75001 Paris',
				paris2: '75002 Paris',
				paris3: '75003 Paris',
				paris8: '75008 Paris',
				paris9: '75009 Paris',
				paris11: '75011 Paris',
				paris12: '75012 Paris',
				paris13: '75013 Paris',
				paris15: '75015 Paris',
				paris16: '75016 Paris',
				paris17: '75017 Paris',
				paris20: '75020 Paris',
				boulogne: '92100 Boulogne-Billancourt',
				courbevoie: '92400 Courbevoie',
				avray: '92410 Ville-d\'Avray'
			},
			nombrePieces: {
				label: 'Nombre de pièces'
			},
			nombreChambres: {
				label: 'Nombre de chambres'
			},
			espaceExterieur: {
				label: 'Espace extérieur'
			},
			budgetMaximum: {
				label: 'Budget maximum',
				tooltip: 'Votre revenu doit être égal à 3 fois le montant du loyer charges comprises'
			},
			dateArrivee: {
				label: 'Date d\'arrivée souhaitée',
				tooltip: 'Nous vous confirmerons votre date d\'arrivée dès la validation de votre dossier'
			},
			commentaire: {
				label: 'Commentaire'
			},
			raisonRecherche: {
				title: 'Quel est le motif de votre recherche ?',
				label: 'Réponse',
				placeholder: 'Choisir',
				sell: 'Vente du logement',
				deposit: 'Congé du propriétaire',
				leave: 'Départ domicile parental',
				uncomfortable: 'Manque de confort',
				tooSmall: 'Appartement trop petit',
				tooLarge: 'Appartement trop grand',
				mutation: 'Mutation',
				rupture: 'Séparation conjugale',
				closerToWork: 'Rapprochement lieu de travail',
				primary: 'Pied-à-terre',
				rentToHigh: 'Loyer trop élevé',
				unsafe: 'Insécurité environnement',
				other: 'Autre'
			},
			profilLocataire: {
				titre: {
					appartement: 'Qui habitera dans le logement ?',
					parking: 'Qui utilisera le parking ?'
				},
				statut: {
					alone: 'Vous seul(e)',
					couple: 'À deux',
					family: 'Votre famille',
					other: 'Autre'
				},
				sousStatut: {
					alone: {
						appartement: 'Vous habitez seul(e), sans enfant',
						parking: 'Vous utiliserez seul le parking'
					},
					couple: {
						appartement: 'Vous occupez votre logement à deux, sans enfant',
						parking: 'Vous utiliserez le parking à deux'
					},
					family: {
						appartement: 'Vous êtes seul(e) ou à deux, avec au moins un enfant',
						parking: ''
					},
					other: {
						appartement: 'Vous êtes en colocation',
						parking: ''
					}
				}
			},
			familleMonoparental: {
				label: 'Vous êtes une famille monoparentale (un seul adulte signataire du bail)'
			},
			nbColoc: {
				label: 'Nombre de colocataires (vous compris)'
			},
			promoCode: {
				placeholder: 'Code privilège',
				description: 'Le code privilège sera pris en compte lors de la validation de votre dossier'
			},
			selectionCopreneur: {
				label: {
					appartement: 'Qui vous suivra dans le futur appartement ?',
					parking: 'Qui partagera la place de parking avec vous ?'
				}
			},
			typeVehicule: {
				label: 'Pour quel type de véhicule ?'
			},
			dimensionVehicule: {
				title: 'Dimensions du véhicule'
			},
			longueur: {
				label: 'Longueur en mm'
			},
			largeur: {
				label: 'Largeur en mm'
			},
			hauteur: {
				label: 'Hauteur en mm'
			},
			isStudent: {
				label: 'Êtes-vous étudiant ?',
				subTitle: 'Si « Oui » et <span>{mainInformation}</span>, il sera nécessaire d\'identifier un garant pour réserver le bien choisi.',
				mainInformation : 'en l\'absence d\'une bourse',
			},
			isBoursier: {
				label: 'Êtes-vous boursier ?',
			}
		}
	},
	preparezArrivee: {
		titre: 'Préparer votre arrivée',
		pdl: {
			titre: 'Point de livraison énergie (PDL)',
			texte: 'Communiquez le N°{numeroPDL} à vos fournisseurs d\'énergie pour l\'ouverture de votre compte.'
		},
		prelAuto: {
			titre: 'Prélèvement automatique',
			texte: 'Adoptez-le et simplifiez-vous la gestion de votre location.',
			lien: 'Souscrire'
		},
		assurance: {
			titre: 'Partager votre attestation d’assurance :',
			texte: 'Pensez à nous transmettre votre attestation d\'assurance au plus tard le premier jour de votre location, au moment de l\'état des lieux d\'entrée.'
		},
		etatLieuxRemiseCles: {
			titre: 'Etat des lieux et remise des clés',
			texteRdvNonPlanifie: 'Votre YouFirst Manager fera l’état des lieux avec vous avant la remise des clés. Pensez à le contacter pour prendre le rendez-vous.',
			texteRdvPlanifie: 'Votre rendez-vous d\'état des lieux est planifié.',
			texteRdvPlanifieCreneaux: 'Vos créneaux de disponibilité ont été transmis à votre YouFirst Manager. Il reviendra vers vous prochainement afin de fixer le rendez-vous.',
			ctaRdvNonPlanifie: 'Planifier mon état des lieux d\'entrée',
			ctaRdvPlanifie: 'Modifier mon rendez-vous',
			erreurChargementOffre: 'Le détail de votre logement n\'a pas pu être chargé. Veuillez réessayer plus tard ou contacter votre YouFirst Manager.',
		},
		finAssurance: {
			titre: 'Partagez votre attestation d’assurance',
			texte: 'Veuillez nous transmettre votre attestation d’assurance. Elle est obligatoire pour l’entrée dans les lieux.',
			lien: 'Déposer'
		},
		modalPriseRdvEdle: {
			titre: 'Choisissez votre date de rendez-vous',
			bouton: 'Confirmez votre rendez-vous',
			aucuneDispo: 'Aucune disponibilité ne vous convient ?',
			aucuneDispoTexte: 'Sélectionnez ci-dessous 3 créneaux, votre YouFirst Manager vous recontactera pour convenir d’une date et d’une heure selon vos préférences',
			choix1: 'Choix 1 *',
			choix2: 'Choix 2',
			choix3: 'Choix 3',
			placeholders: {
				jour: 'Jour',
				creneau: 'Créneau'
			},
			enums: {
				creneaux: {
					MATIN1: '8h-10h',
					MATIN2: '10h-12h',
					APREM1: '14h-16h',
					APREM2: '16h-18h',
				},
				jours: {
					LUNDI: 'Lundi',
					MARDI: 'Mardi',
					MERCREDI: 'Mercredi',
					JEUDI: 'Jeudi',
					VENDREDI: 'Vendredi'
				}
			},
			edleValide: 'Votre rendez-vous pour l\'état des lieux d\'entrée a bien été confirmé',
			edlsValide: 'Votre rendez-vous pour l\'état des lieux de sortie a bien été confirmé',
		}
	},
	preparezDepart: {
		titre: 'Préparer votre départ',
		etatLieuxRemiseCles: {
			titre: 'Etat des lieux et remise des clés',
			texteRdvNonPlanifie: 'Votre YouFirst Manager fera l’état des lieux avec vous avant la remise des clés. Pensez à le contacter pour prendre le rendez-vous.',
			texteRdvPlanifie: 'Votre rendez-vous d\'état des lieux est planifié.',
			texteRdvPlanifieCreneaux: 'Vos créneaux de disponibilité ont été transmis à votre YouFirst Manager. Il reviendra vers vous prochainement afin de fixer le rendez-vous.',
			ctaRdvNonPlanifie: 'Planifier mon état des lieux de sortie',
			ctaRdvPlanifie: 'Modifier mon rendez-vous',
		}
	}
}

export default flatten<typeof target, ModelTranslations>(target)
